let map;
let markers;
let bounds;
let activeInfoWindow;

function isMobile() {
	// This width roughly lines up with $location-listing-breakpoint
	if (window.innerWidth < 896) {
		return true;
	}

	return false;
}

function openInfoWindow(infowindow, marker, map) {
	zoomToMarker(marker, map);

	if (activeInfoWindow) {
		activeInfoWindow.close();
	}
	activeInfoWindow = infowindow;

	infowindow.open({
		anchor: marker,
		map,
	});
}

function zoomToMarker(marker, map) {
	let mapZoom = isMobile() ? 11 : 11;

	map.setZoom(mapZoom);

	map.panTo(marker.position);
}

function zoomToAllMarkers(map, bounds) {
	map.fitBounds(bounds);
}

function findClosestLocations(input, map, locations) {
	// set up list of potential destinations
	var destinations = [];
	locations.forEach(function (location) {
		if (location.dataset.zipcode && !destinations.includes(location.dataset.zipcode)) {
			destinations.push(location.dataset.zipcode);
		}
	});

	// console.log(destinations);

	// set up distance matrix API/request
	const service = new google.maps.DistanceMatrixService();
	const request = {
		origins: [input],
		destinations: destinations,
		travelMode: "DRIVING",
		unitSystem: google.maps.UnitSystem.IMPERIAL,
	};

	// get distance matrix response
	service.getDistanceMatrix(request).then(function (response) {
		// console.log(response);

		var distances = response.rows[0].elements;

		var results = [];

		// assemble array of results
		distances.forEach(function (result, index) {
			// get zip code out of the reformatted destinations

			// console.log(response.destinationAddresses[index]);
			var destination_str = response.destinationAddresses[index].replace(", USA", "");
			// console.log(destination_str);
			var destination_array = destination_str.split(" ");
			// console.log(destination_array);
			var zipcode = destination_array.pop();
			// console.log(zipcode);

			// Check if this is a valid zip code
			zipcode_regex = /^\d{5}(-\d{4})?$/;
			if (!zipcode_regex) {
				return;
			}

			results.push({
				zipcode: zipcode,
				distance: result.distance.text,
				value: result.distance.value,
			});
		});
		// sort results array by distance
		results.sort((a, b) => a.value - b.value);

		// console.log(results);

		// sort content on page by looping through results, then locations
		results.forEach(function (result, index) {
			locations.forEach(function (location) {
				if (location.dataset.zipcode === result.zipcode) {
					location.parentNode.append(location);
					if (index === 0) {
						location.querySelector("[data-map-infowindow-trigger]").click();
					}
				}
			});
		});
	});
}

async function initMap() {
	const { Map } = await google.maps.importLibrary("maps");
	const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary("marker");

	map = new Map(document.getElementById("map"), {
		mapId: googleMapsMapID,

		// just a roughly correct zoom level and center
		center: { lat: 31.15363, lng: -92.46798 },
		zoom: 6,

		gestureHandling: "cooperative",
		disableDefaultUI: isMobile(),
		zoomControl: true,
		fullscreenControl: true,
		streetViewControl: false,
	});

	bounds = new google.maps.LatLngBounds();

	const locations = document.querySelectorAll(".map-marker[data-lat][data-lng]");
	locations.forEach(function (location) {
		// console.log(location);
		// console.log(location.dataset.lat);
		// console.log(location.dataset.lng);

		let position = {
			lat: parseFloat(location.dataset.lat),
			lng: parseFloat(location.dataset.lng),
		};
		// console.log(position);

		const customPin = new PinElement({
			// glyph: "",
			scale: 0.75,
			background: "var(--color-brand-primary-maroon)",
			borderColor: "var(--color-brand-primary-maroon)",
			glyphColor: "var(--color-brand-secondary-yellow)",
		});

		const marker = new AdvancedMarkerElement({
			map,
			position: position,
			title: location.dataset.title,
			gmpClickable: true,
			content: customPin.element,
		});

		let infoWindowHeader = document.createElement("p");
		infoWindowHeader.classList.add("is-style-subhead", "has-md-font-size");
		infoWindowHeader.textContent = location.dataset.title;

		let infoWindowContent = document.createElement("div");
		infoWindowContent.classList.add("is-layout-flow", "has-sm-font-size");

		let infoWindowElements = location.querySelectorAll("[data-map-infowindow-content]");
		infoWindowElements.forEach(function (element) {
			var clone = element.cloneNode(true);
			infoWindowContent.append(clone);
		});

		let infoWindowTriggers = location.querySelectorAll("[data-map-infowindow-trigger]");
		infoWindowTriggers.forEach(function (element) {
			element.addEventListener("click", function (event) {
				event.preventDefault();

				openInfoWindow(infowindow, marker, map);

				document.getElementById("map").scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
			});
		});

		const infowindow = new google.maps.InfoWindow({
			ariaLabel: location.dataset.title,
			headerContent: infoWindowHeader,
			content: infoWindowContent,
		});

		infowindow.addListener("close", (event) => {
			zoomToAllMarkers(map, bounds);
		});

		marker.addListener("click", (event) => {
			if (isMobile()) {
				window.location = location.dataset.url;
			} else {
				openInfoWindow(infowindow, marker, map);
			}

			const listingItem = location;
			listingItem.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
		});

		bounds.extend(marker.position);
	});

	map.fitBounds(bounds);

	const location_form = document.querySelector("#find-location");
	location_form.addEventListener("submit", function (event) {
		event.preventDefault();

		var field = event.target.querySelector("#location-search");
		var validity = field.validity;

		if (validity.valid) {
			var input = field.value;
			findClosestLocations(input, map, locations);
		}
	});
}

initMap();
